import React from 'react'

const CustomPrivacyHeading = ({text,myClass}) => {
  return (
    <h4
      className={`${myClass} text-[32px] max-md:text-3xl max-sm:text-2xl font-extrabold leading-[111%] text-[#010101]`}
    >
      {text}
    </h4>
  );
}

export default CustomPrivacyHeading